// extracted by mini-css-extract-plugin
export default {"grades":"TotalGrades_grades__mZxXT","grades__number":"TotalGrades_grades__number__Cxg7h"};